import Parse from 'parse'

'use strict'

export const BaseParseObject = Parse.Object.extend('BaseParseObject', {
  displayInSkySafariWidget: (ssww) => {
    ssww.reset()
    return ssww
  }
})

export default BaseParseObject
